import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import SchoolfeeSvg      from '../img/schoolfee.svg';
import CourseSvg         from '../img/course.svg';
import StudentSvg        from '../img/student.svg';
import StaffSvg          from '../img/staff1.svg';
import GradeSvg          from '../img/grade.svg';
import CommunicationSvg  from '../img/communication.svg';
import ScheduleSvg       from '../img/schedule.svg';
import AttendanceSvg     from '../img/attendance.svg';
import PlanSvg           from '../img/plan.svg';
import ArrowSvg          from '../img/arrow.svg';
import HomeSvg           from '../img/home.svg';
import AdminSvg          from '../img/admin2.svg';
import AssignmentsSvg    from '../img/assignment.svg';
import LockSvg           from '../img/lock.svg';
import WithdrawSvg           from '../img/withdraw.svg';

const Sidebar = ({ allowedRoutes = [] }) => {
    const location = useLocation();

    const items = [
        { to: '/home',                icon: HomeSvg,          text: 'Home'                },
        { to: '/attendance',          icon: AttendanceSvg,    text: 'Attendance'          },
        { to: '/learning-materials',  icon: AssignmentsSvg,   text: 'Learning Materials'  },
        { to: '/change-password',     icon: LockSvg,          text: 'change Password'},
        { to: '/communication',       icon: CommunicationSvg, text: 'Communication'       },
        { to: '/subjects',            icon: CourseSvg,        text: 'Subjects'            },
        { to: '/grades',              icon: GradeSvg,         text: 'Academic Reports'    },
        { to: '/lesson plan library', icon: PlanSvg,          text: 'Lesson Plan Library' },
        { to: '/scheduling',          icon: ScheduleSvg,      text: 'Scheduling'          },
        { to: '/staffs',              icon: StaffSvg,         text: 'Staffs'              },
        { to: '/students',            icon: StudentSvg,       text: 'Students'            },
        { to: '/school-fee',          icon: SchoolfeeSvg,     text: 'School Fee'          },
         { to: '/withdraw',         icon: WithdrawSvg,         text: 'Withdrawals'         },
        { to: '/admin-panel',         icon: AdminSvg,         text: 'Admin Panel'         },
    ];

    return (
        <div className="sidebar">
            <ul>
                {items
                    .filter(item => allowedRoutes.includes(item.to))
                    .map((item, index) => (
                        <li
                            key={index}
                            className={`sidebar-item ${location.pathname === item.to ? 'active' : ''}`}
                            title={item.text}
                        >
                            <Link to={item.to}>
                                <img
                                    className="sidebar-icon"
                                    src={item.icon}
                                    alt={`${item.text.toLowerCase()} icon`}
                                />
                                <span className="sidebar-label">{item.text}</span>
                                <img className="arrow-icon" src={ArrowSvg} alt="arrow icon" />
                            </Link>
                        </li>
                    ))}
            </ul>
        </div>
    );
};

export default Sidebar;